import holyweekIcon from "./../assets/imgs/icons/cross.png";
import infoIcon from "./../assets/imgs/icons/info-black.svg";
// import holyweekIconDarkMode from "./../assets/imgs/icons/cross-white.png";

export const HomePageNotices = [
    // {
    //     message: "In observance of the holiday, please expect delays on application processing",
    //     id: "holy-week",
    //     type: "warning",
    //     // showIn: 3000, // (will show after 3 seconds)
    //     showFor: 60000, // (will show for 1 min)
    //     start: "2023-04-04 00:00:00",
    //     end: "2023-04-11 00:00:00",
    //     icon: holyweekIcon,
    //     iconDarkMode: holyweekIconDarkMode,
    // },
];
export const HomePageStaticNotices = [
    {
        type: "error",
        message: "In observance of the holiday, please expect delays on application processing.",
        id: "holy-week",
        start: "2024-03-28 00:00:00",
        end: "2024-04-01 00:00:00",
        icon: holyweekIcon,
    },
    {
        type: "warning-orange",
        message:
            "SeekCap is currently under maintenance from **June 3, 2023** until **June 4, 2023**. Loan applications will temporarily be unavailable during this time. In the meantime, feel free to browse through our [loan products](/products).",
        id: "maintenance-actual1",
        start: "2023-05-03 00:00:00",
        end: "2023-06-05 00:00:00",
        showInDashboard: true,
        showInLoanApplication: true,
    },
    {
        type: "warning-orange",
        message:
            "SeekCap will be under maintenance from April 19, 6PM to April 20, 6AM. You may sign up for an account but will not be able to apply for a loan.",
        id: "maintenance-banner",
        start: "2024-04-19 14:00:00",
        end: "2024-04-20 06:00:00",
        showInDashboard: true,
        showInLoanApplication: true,
        flag: "maintenance-banner",
    },
    {
        type: "error",
        message: "In observance of the Independence Day holiday, please expect delays on application processing.",
        id: "independence-day",
        start: "2024-06-12 00:00:00",
        end: "2024-06-13 00:00:00",
        icon: infoIcon,
    },
];

export const NoticeIcon = {
    info: infoIcon,
    holyweek: holyweekIcon,
};
